<header [ngClass]="{ 'hide-border': hideBorder }">
  <ng-content select="[custom-title]"></ng-content>
  @if (title) {
    <div class="flex items-center gap-3">
      @if (title) {
        <h1 class="page-title">{{ title }}</h1>
      }
    </div>
  }

  <div class="filters">
    <ng-content></ng-content>
  </div>
</header>
